<template>
  <div>
    <el-row class="contents">
      <!-- 查询条件 -->
      <el-col :span="24" class="handleQuery">
        <el-form :inline="true" :model="queryParams" class="form" size="small" label-width="70px">
          <el-form-item label="开始时间">
            <el-date-picker v-model="queryParams.startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="queryParams.endTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="请求方式">
            <el-input v-model="queryParams.method" placeholder="请求方式"></el-input>
          </el-form-item>
          <el-form-item label="请求url">
            <el-input v-model="queryParams.url" placeholder="请求url"></el-input>
          </el-form-item>
          <el-form-item label="请求ip">
            <el-input v-model="queryParams.ip" placeholder="请求ip"></el-input>
          </el-form-item>
          <el-form-item label="异常内容">
            <el-input v-model="queryParams.error" placeholder="异常信息"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!-- 列表 -->
      <el-col :span="24">
        <el-table v-loading="loading" :data="datas" stripe border style="width: 100%;" ref="multipleTable"
          tooltip-effect="dark" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="method" label="请求方式">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="url" label="请求地址">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="param" label="参数">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="error" label="异常信息">
            <template slot-scope="scope">
              <div v-if="scope.row.error&&scope.row.error.length>20" style="text-align: center;">
                {{scope.row.error.substring(0, 20)}}<br />
                <el-button size="mini" @click="showError(scope.row)" slot="reference">查看详情</el-button>
              </div>
              <div v-else>
                {{scope.row.error}}<br />
              </div>
            </template>

          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="ip" label="ip">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="token" label="token">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="loginType" label="loginType">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="userAgent" label="user-Agent">
          </el-table-column>
          <el-table-column sortable="custom" :sort-orders="['descending', 'ascending', null]" prop="createTime" label="操作时间">
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50,100]"
          :current-page="queryParams.currentPage" :page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange"
          @current-change="pageCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>


    <el-dialog title="异常信息" :visible.sync="dialogVisible">
      <el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-input readonly type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :value="error">
            </el-input>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import SearchBase from '@/components/layout/base/base-search-front.vue'
  export default {
    extends: SearchBase,
    data() {
      return {
        url: "cm/error/log",
				name:"异常日志",
        error: null,
      };
    },
    methods: {
      showError(row) {
        this.error = row.error
        this.dialogVisible = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/errorLog.vue